var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1297_629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 2.00001H12.6667V0.666672H11.3334V2.00001H4.66671V0.666672H3.33337V2.00001H2.66671C1.93337 2.00001 1.33337 2.6 1.33337 3.33334V14C1.33337 14.7333 1.93337 15.3333 2.66671 15.3333H13.3334C14.0667 15.3333 14.6667 14.7333 14.6667 14V3.33334C14.6667 2.6 14.0667 2.00001 13.3334 2.00001ZM13.3334 14H2.66671V5.33334H13.3334V14Z",
    fill: "#FF782D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1297_629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOrange);
export default __webpack_public_path__ + "static/media/calendar_orange.2392db0494a2da8f147c6448ef654d0c.svg";
export { ForwardRef as ReactComponent };